import { createPinia } from 'pinia'
import type { App } from 'vue'
import { resetStore } from './reset-store'

export const store = createPinia()

store.use(resetStore)

export default function (app: App) {
  app.use(store)
}
